<!-- Modal for success/error dialogs -->
<span id="messagemodalbtn" type="button" data-toggle="modal" data-target="#messagemodal"></span>
<div class="modal fade" id="messagemodal" tabindex="-1" role="dialog" aria-labelledby="messagemodalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="message-wrapper">
      <!-- Success Dialog -->
      <div id="messagemodal-type">
        <div class="col-sm-12">
          <div class="message-icon"><i id="messagemodal-icon"></i></div>
          <div class="message-title" id="messagemodal-title"></div>
          <div class="message-info">
            <div>
              <p id="messagemodal-text">
              </p>
            </div>
            <div class="clear"></div>
          </div>

          <div class="col-sm-12">
            <div class="col-xs-6 col-xs-offset-3 notice-button-wrap">
              <button type="submit" class="notice-button" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal for success/error dialogs -->
